import { ZoidCore } from '@zoidpay-tech/zoidcore-web3-toolkit'

import { EthTokenCreate } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/modelsEthToken/EthTokenCreate'
import { BscTokenCreate } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/modelsBscToken/BscTokenCreate'
import { MaticTokenCreate } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/modelsMaticToken/MaticTokenCreate'
import { EsdtIssue } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/esdt/issue'

import { EthNftCreateCollection } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/index.js'
import { BscNftCreateCollection } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/index.js'
import { MaticNftCreateColelction } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/index.js'
import { NftIssue } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/nft/nftIssue.js'

import { EthNftMint } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/index.js'
import { BscNftMint } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/index.js'
import { MaticNftMint } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/index.js'
import { NftCreate } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/nft/nftCreate.js'

import { EthTransfer } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/modelsEthToken/EthTransfer'
import { BscTokenTransfer } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models'
import { MaticTransferToken } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models'
import { EsdtTransfer } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/esdt/transfer'

import { EthGetTxStatus } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/modelsEthSmartContract/getStatus'
import { MaticGetTxStatus } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/modelsMaticSmartContract/maticCheckStatus'
import { BscGetTxStatus } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/modelsBscSmartContract/BscGetTxStatus'

import { ValidateProject } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/utilities/validateProject.js'
import { CheckValidateProject } from '@zoidpay-tech/zoidcore-web3-toolkit/build/models/utilities/checkValidateProject.js'

import { chainType, networkType } from 'src/util/types.js'
import { axiosInstance } from 'src/util/axios.js'

export interface ITokenDetails {
  name: string
  supply: string
  symbol: string
  decimals: string
}

export const createToken = async (
  payload: EthTokenCreate | BscTokenCreate | MaticTokenCreate | EsdtIssue,
  selectedChain: chainType,
  userToken: string,
) => {
  const initializer = {
    apiKey: '',
    authorization: userToken,
    env: process.env.REACT_APP_ENVIRONMENT === 'development' ? 'debug' : '',
  }
  const zoid = new ZoidCore(initializer)

  try {
    let response
    switch (selectedChain) {
      case 'ETHEREUM':
        response = await zoid.ethereum.ethCreateToken(payload as EthTokenCreate)
        break
      case 'BNB':
        response = await zoid.bsc.bscIssueToken(payload as BscTokenCreate)
        break
      case 'POLYGON':
        response = await zoid.polygon.polygonCreateToken(payload as MaticTokenCreate)
        break
      case 'MULTIVERSX':
        response = await zoid.multiversX.esdtIssueToken(payload as EsdtIssue)
        break
    }
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const createNftCollection = async (
  payload: EthNftCreateCollection | BscNftCreateCollection | MaticNftCreateColelction | NftIssue,
  selectedChain: chainType,
  userToken: string,
) => {
  const initializer = {
    apiKey: '',
    authorization: userToken,
    env: process.env.REACT_APP_ENVIRONMENT === 'development' ? 'debug' : '',
  }
  const zoid = new ZoidCore(initializer)

  try {
    let response
    switch (selectedChain) {
      case 'ETHEREUM':
        response = await zoid.ethereum.ethNftCreate(payload as EthNftCreateCollection)
        break
      case 'BNB':
        response = await zoid.bsc.bscNftCreateCollection(payload as BscNftCreateCollection)
        break
      case 'POLYGON':
        response = await zoid.polygon.polygonNftCreate(payload as MaticNftCreateColelction)
        break
      case 'MULTIVERSX':
        response = await zoid.multiversX.nftIssue(payload as NftIssue)
        break
    }
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const mintNft = async (
  payload: EthNftMint | BscNftMint | MaticNftMint | NftCreate,
  selectedChain: chainType,
  userToken: string,
) => {
  const initializer = {
    apiKey: '',
    authorization: userToken,
    env: process.env.REACT_APP_ENVIRONMENT === 'development' ? 'debug' : '',
  }
  const zoid = new ZoidCore(initializer)

  try {
    let response
    switch (selectedChain) {
      case 'ETHEREUM':
        response = await zoid.ethereum.ethMintNft(payload as EthNftMint)
        break
      case 'BNB':
        response = await zoid.bsc.bscMintNft(payload as BscNftMint)
        break
      case 'POLYGON':
        response = await zoid.polygon.polygonMintNft(payload as MaticNftMint)
        break
      case 'MULTIVERSX':
        response = await zoid.multiversX.nftCreate(payload as NftCreate)
        break
    }
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const transferToken = async (
  payload: EthTransfer | BscTokenTransfer | MaticTransferToken | EsdtTransfer,
  selectedChain: chainType,
  userToken: string,
) => {
  const initializer = {
    apiKey: '',
    authorization: userToken,
    env: process.env.REACT_APP_ENVIRONMENT === 'development' ? 'debug' : '',
  }
  const zoid = new ZoidCore(initializer)

  try {
    let response
    switch (selectedChain) {
      case 'ETHEREUM':
        response = await zoid.ethereum.ethTransferToken(payload as EthTransfer)
        break
      case 'BNB':
        response = await zoid.bsc.bscTransferToken(payload as BscTokenTransfer)
        break
      case 'POLYGON':
        response = await zoid.polygon.polygonTranferToken(payload as MaticTransferToken)
        break
      case 'MULTIVERSX':
        response = await zoid.multiversX.esdtTransferToken(payload as EsdtTransfer)
        break
    }
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getTxStatus = async (
  payload: EthGetTxStatus | BscGetTxStatus | MaticGetTxStatus,
  selectedChain: chainType,
  userToken: string,
) => {
  const initializer = {
    apiKey: '',
    authorization: userToken,
    env: process.env.REACT_APP_ENVIRONMENT === 'development' ? 'debug' : '',
  }
  const zoid = new ZoidCore(initializer)

  try {
    let response
    switch (selectedChain) {
      case 'ETHEREUM':
        response = await zoid.ethereum.ethTxStatus(payload as EthGetTxStatus)
        break
      case 'BNB':
        response = await zoid.bsc.bscTxStatus(payload as BscGetTxStatus)
        break
      case 'POLYGON':
        response = await zoid.polygon.polygonGetTxStatus(payload as MaticGetTxStatus)
        break
    }
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const validateProject = async (project: any, accessToken: string) => {
  const initializer = {
    apiKey: '',
    authorization: accessToken,
    env: process.env.REACT_APP_ENVIRONMENT === 'development' ? 'debug' : '',
  }
  const zoid = new ZoidCore(initializer)

  try {
    let txReceipt
    if (project.data?.chain !== 'multiversx') {
      txReceipt = await zoid.utils.getTxReceipt({
        txHash: project?.txHash,
        networkProvider: project?.data.networkProvider,
      })
    }

    const validatePayload: ValidateProject = {
      id: project?.id,
      contractAddress:
        project.data?.chain === 'multiversx'
          ? project.data?.tokenTicker
          : txReceipt?.data?.data?.contractAddress,
    }

    const res = await zoid.utils.validateProject(validatePayload)

    return res?.data?.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const checkValidationStatus = async (project: any, accessToken: string) => {
  const initializer = {
    apiKey: '',
    authorization: accessToken,
    env: process.env.REACT_APP_ENVIRONMENT === 'development' ? 'debug' : '',
  }
  const zoid = new ZoidCore(initializer)

  try {
    let txReceipt
    if (project?.data?.chain === 'multiversx') {
      txReceipt = null
    } else {
      txReceipt = await zoid.utils.getTxReceipt({
        txHash: project?.txHash,
        networkProvider: project?.data.networkProvider,
      })
    }

    const validatePayload: CheckValidateProject = {
      id: project?.id,
      smartContractAddress: txReceipt?.data?.data?.contractAddress,
    }

    const res = await zoid.utils.checkValidate(validatePayload)
    return res?.data?.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getNftCollections = async (address: string, network: networkType) => {
  try {
    const response = await axiosInstance.get(
      `https://${
        network === 'mainnet' ? '' : 'devnet-'
      }api.multiversx.com/accounts/${address}/roles/collections`,
    )
    return response.data
  } catch (error) {
    // Dispatch failure action
    console.error(error)
  }
}

export const createStakeSc = async (payload: any) => {
  //operation can be: createStakingContract, createVestingContract, approveToken, approveContract, addRewards

  // const initializer = {
  //   apiKey: "",
  //   authorization: userToken,
  //   env: process.env.REACT_APP_ENVIRONMENT === "development" ? "debug" : "",
  // };
  // const zoid = new ZoidCore(initializer);

  try {
    const response = await axiosInstance.post('/blockchain-helpers/createStakingContract', payload)
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}
export const createVestSc = async (payload: any) => {
  //operation can be: createStakingContract, createVestingContract, approveToken, approveContract, addRewards

  // const initializer = {
  //   apiKey: "",
  //   authorization: userToken,
  //   env: process.env.REACT_APP_ENVIRONMENT === "development" ? "debug" : "",
  // };
  // const zoid = new ZoidCore(initializer);

  try {
    const response = await axiosInstance.post('/blockchain-helpers/createVesting', payload)
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const checkTokenValidation = async (
  userAddress: string,
  rpc: string,
  scAddress: string,
  chain: chainType,
  environment: networkType,
  chainId?: number,
) => {
  try {
    if (chain === 'MULTIVERSX') {
      return
    }
    const urlParam = chain === 'ETHEREUM' ? 'eth' : chain === 'BNB' ? 'bsc' : 'matic'

    const response = await axiosInstance.post(
      '/blockchain-helpers/' + urlParam + '/smartContract/getAbi',
      {
        address: userAddress,
        networkProvider: rpc,
        smartContractAddress: scAddress,
        environment,
        ...(chain === 'ETHEREUM' ? { chainId } : {}),
      },
    )
    return response.data?.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getTokenDetails = async (
  scAddress: string,
  rpc: string,
  chain: chainType,
  environment: networkType,
  chainId?: number,
) => {
  try {
    if (chain === 'MULTIVERSX') {
      return
    }

    const response = await axiosInstance.post('/blockchain-helpers/getTokenDetails', {
      scAddress,
      chain: chain.toLowerCase(),
      environment,
      networkProvider: rpc,
      ...(chain === 'ETHEREUM' ? { chainId } : {}),
    })
    return response.data?.data
  } catch (error) {
    console.error(error)
    throw error
  }
}
